import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Logo from '../Login/Logo';
import ToastMessage from '../ToastMessage/ToastMessage';

function Main() {
  const location = useLocation();
  const [toastType, setToastType] = useState<'success' | 'error'>('success');
  const [toast, setToast] = useState('');

  useEffect(() => {
    if (location?.state?.message) {
      setToastType('success');
      setToast(location?.state?.message);
      window.history.replaceState({}, '');
    }
  }, []);

  return (
    <>
      <Box className='auth-page'>
        <Box className='center'>
          <Box className='body' sx={{ border: 'unset !important' }}>
            <Logo />
          </Box>
        </Box>
      </Box>
      <ToastMessage toast={toast} close={() => setToast('')} messageType={toastType} />
    </>
  );
}

export default Main;
